import './App.css';
import MainContainer from './containers/MainContainer';
import Layout from './layouts/Layout';

function App() {
  return (
    <Layout>
    <MainContainer />
    </Layout>
  );
}

export default App;
